import routes from 'config/routes';
import { RouteIdentifier } from 'types/routing';

/**
 * Retrieve a route by its key
 *
 * @param {RouteIdentifier} routeId Target route key
 */
export const getRouteById = (routeId: RouteIdentifier) => {
  // Attempt to find the route with the specified key
  const route = routes.find(route => route.id === routeId);

  // Fail if route was not found
  if (!route) {
    throw new Error(`Invalid route key specified (${routeId.toString()})`);
  }

  return route;
};
